export var ManualActivityTypeEnum;
(function (ManualActivityTypeEnum) {
    ManualActivityTypeEnum[ManualActivityTypeEnum["Resignation"] = 0] = "Resignation";
    ManualActivityTypeEnum[ManualActivityTypeEnum["BirthAdoption"] = 1] = "BirthAdoption";
    ManualActivityTypeEnum[ManualActivityTypeEnum["EarlyRetirement"] = 2] = "EarlyRetirement";
    ManualActivityTypeEnum[ManualActivityTypeEnum["Sick"] = 3] = "Sick";
    ManualActivityTypeEnum[ManualActivityTypeEnum["Funeral"] = 4] = "Funeral";
    ManualActivityTypeEnum[ManualActivityTypeEnum["MarriageRegistration"] = 5] = "MarriageRegistration";
    ManualActivityTypeEnum[ManualActivityTypeEnum["EmployeeOnboarding"] = 6] = "EmployeeOnboarding";
})(ManualActivityTypeEnum || (ManualActivityTypeEnum = {}));
export const ManualActivityTypeEnumDisplay = {
    [ManualActivityTypeEnum.Resignation]: 'Resignation',
    [ManualActivityTypeEnum.BirthAdoption]: 'Birth/Adoption',
    [ManualActivityTypeEnum.EarlyRetirement]: 'Early Retirement',
    [ManualActivityTypeEnum.Sick]: 'Sick',
    [ManualActivityTypeEnum.Funeral]: 'Funeral',
    [ManualActivityTypeEnum.MarriageRegistration]: 'Marriage Registration',
    [ManualActivityTypeEnum.EmployeeOnboarding]: 'Employee Onboarding'
};
